export const space = {
    containerOuterPadding: '16px',
};
